import React, { useState, useEffect } from 'react';
import {
  FiArrowRight,
} from 'react-icons/fi';
import styles from './ProcessButton.module.css';

export default function ProcessButton(props) {
  const {
    action, text, style, Icon, actionFinished=false
  } = props;

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let mounted = true;
    if (loading && action) {
      const executeAction = async () => {
        await action();
        if (mounted) setLoading(false);
      };
      try {
        executeAction();
      } catch (error) {
        setLoading(false);
        throw error;
      }
      return () => mounted = false;
    }
  }, [loading]);

  useEffect(()=>{
    if(actionFinished)
      setLoading(false);
  },[actionFinished])

  return (
    <div className={styles.nextBarContent}>
      <button type="button" onClick={loading ? () => {} : () => setLoading(true)} className={styles.nextBar} style={style}>
        {Icon ?? <FiArrowRight size={15} color="#FFF" strokeWidth="2" /> }
        <p className={styles.nextBarText}>
          {(loading) ? 'Carregando...' : text ?? 'Próximo passo'}
        </p>
      </button>
    </div>
  );
}
